import React from 'react';
import Helmet from 'react-helmet';

export default ({ title, desc, keywords }) => (
  <Helmet>
    <title>{ title }</title>
    <meta name="description" content={ desc }/>
    <meta name="keywords" content={ keywords }/>
  </Helmet>
);